var utils = {
    forceFileDownload: function (response, extension, show = false,nombre = 'temp', type = 'application/pdf') {
        if (show) {
            const url = window.URL.createObjectURL(new Blob([response], { type: type }));
            window.open(url);
        } else {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nombre + extension)
            document.body.appendChild(link)
            link.click()
        }
    },
    convertBase64toBytes: function(base64Pdf){
      // Convertir la respuesta en una cadena Base64
      const base64String = base64Pdf;

      // Decodificar la cadena Base64 a datos binarios
      const binaryString = atob(base64String);

      // Crear un Uint8Array con los datos binarios
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);
      for (let i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes;
    },
    formatDate: function(dateString){
        const months = ["Ene", "Feb", "Mar","Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
        let current_datetime = new Date(dateString);
        let formatted_date = current_datetime.getUTCDate() + "-" + months[current_datetime.getUTCMonth()] + "-" + current_datetime.getUTCFullYear();
        return formatted_date;
    },
    formatDateTimeToTime: function(dateString){
      let current_datetime = new Date(dateString);
      let hour = current_datetime.getHours();
      let minutes = current_datetime.getMinutes();
      let ampm = hour >=12 ? 'pm' : 'am';
      hour = hour % 12;
      hour = hour ? hour : 12;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      let formatted_time = hour + ':' + minutes + ' ' + ampm;
      return formatted_time;
    },
    formatDateToShort: function(dateString){
        let current_datetime = new Date(dateString);
        let formatted_date = current_datetime.getMonth() + '/' + current_datetime.getDate() + '/' + current_datetime.getFullYear();
        return formatted_date;
    },
    getAutoFitColumns: function(json){
        const jsonKeys = Object.keys(json[0]);
        let objectMaxLength = [];
        for (let i = 0; i < json.length; i++) {
        let value = json[i];
        for (let j = 0; j < jsonKeys.length; j++) {
            if (typeof value[jsonKeys[j]] == "number") {
            objectMaxLength[j] = 10;
            } else {

            const l = value[jsonKeys[j]] ? value[jsonKeys[j]].length : 0;

            objectMaxLength[j] =
                objectMaxLength[j] >= l
                ? objectMaxLength[j]
                : l;
            }
        }

        let key = jsonKeys;
        for (let j = 0; j < key.length; j++) {
            objectMaxLength[j] =
            objectMaxLength[j] >= key[j].length
                ? objectMaxLength[j]
                : key[j].length;
        }
        }

        const wscols = objectMaxLength.map(w => { return { width: w} });

        return wscols;
    },
}
export default utils;
